import { useContext } from 'react';

import {
  type FocusContextProps,
  FocusContext,
} from '../contexts/FocusContext.js';

/**
 * Internal hook wrapper for accessing the FocusContext.
 * @internal
 */
export const useFocusContext = (): FocusContextProps => {
  return useContext(FocusContext);
};
